// eslint-disable-next-line no-unused-vars
import React from 'react';
import { InstagramLogo } from '@phosphor-icons/react/dist/ssr/InstagramLogo';
import { COLORS } from '../../../styles/UISystem';

/**
 * IconInstagram Component
 *
 * Instagram icon with different states (default, active, selected)
 */
export const IconInstagram = ({ state = 'default', size = 28, color, ...props }) => {
  // Determine background color based on state
  const getBackgroundColor = () => {
    switch (state) {
      case 'active':
        return COLORS.LIGHT_GRAY;
      case 'selected':
        return COLORS.MEDIUM_DARK_GRAY;
      default:
        return 'transparent';
    }
  };

  // Use provided color or default to DARK_GRAY
  const iconColor = color || COLORS.DARK_GRAY;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '40px',
        height: '40px',
        borderRadius: '10px',
        backgroundColor: getBackgroundColor(),
        ...props.style,
      }}
      {...props}
    >
      <InstagramLogo size={size} color={iconColor} weight="regular" />
    </div>
  );
};

/**
 * IconInstagramExample Component
 *
 * Used for displaying IconInstagram examples in the UI System
 */
export const IconInstagramExample = () => {
  return (
    <div style={{ marginBottom: '40px' }}>
      <div
        style={{
          fontSize: '24px',
          fontWeight: 'bold',
          color: COLORS.DARK_GRAY,
          marginBottom: '32px',
          textAlign: 'center',
        }}
      >
        IconInstagram
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '16px',
          maxWidth: '500px',
          margin: '0 auto',
        }}
      >
        {/* Default state */}
        <div style={{ textAlign: 'center' }}>
          <div style={{ marginBottom: '8px', fontSize: '16px', color: COLORS.DARK_GRAY }}>
            default
          </div>
          <IconInstagram state="default" />
        </div>

        {/* Active state */}
        <div style={{ textAlign: 'center' }}>
          <div style={{ marginBottom: '8px', fontSize: '16px', color: COLORS.DARK_GRAY }}>
            active
          </div>
          <IconInstagram state="active" />
        </div>

        {/* Selected state */}
        <div style={{ textAlign: 'center' }}>
          <div style={{ marginBottom: '8px', fontSize: '16px', color: COLORS.DARK_GRAY }}>
            selected
          </div>
          <IconInstagram state="selected" />
        </div>
      </div>
    </div>
  );
};

export default IconInstagram;
